import React from 'react';
import styled from 'styled-components';
import { Heading } from 'components/Heading';

type SubHeadingProps = React.ComponentProps<typeof Heading> & {
  children: React.ReactNode;
  icon?: React.ComponentType<any>;
};

const SubHeading = ({ children, icon, ...props }: SubHeadingProps) => (
  <StyledHeading size="large" level={2} {...props}>
    <Separator>
      {icon && <IconSpacing as={icon} />}
      {children}
    </Separator>
  </StyledHeading>
);

const StyledHeading = styled(Heading)`
  overflow: hidden;
`;

const Separator = styled.span`
  position: relative;
  padding: 0 ${props => props.theme.spacing.medium};
  vertical-align: middle;
  display: inline-block;

  &::before,
  &::after {
    content: '';
    background: ${props => props.theme.color.subtle};
    position: absolute;
    height: 2px;
    top: 50%;
    transform: translateY(-50%);
    width: 900px;
  }

  &::before {
    right: 100%;
  }

  &::after {
    left: 100%;
  }
`;

const IconSpacing = styled.span`
  margin-right: ${props => props.theme.spacing.small};
  color: ${props => props.theme.color.textSubtle};
`;

export { SubHeading };
